import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle, ArrowRight } from 'lucide-react';
import { useCurrency } from '../contexts/CurrencyContext';
import { trackAddToCart } from '../utils/metaPixel';
export function ProductShowcase() {
  const {
    formattedPrice,
    isLoading
  } = useCurrency();
  const deliverables = ['Bedtime Pass printables (multiple styles)', 'Kid-friendly "Bedtime Rules" one-pager', 'Silent Return Protocol (quick-start)', '2-Minute Script Cards (common scenarios)', '7-day tracker (optional)', 'Emergency cards (top bedtime derailers)', "Partner Alignment Sheet (so you're not running two different bedtimes)"];
  return <section className="w-full bg-[#faf6ef] py-24 px-6" data-id="element-193">
      <div className="max-w-[800px] mx-auto" data-id="element-194">
        <motion.div initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="flex justify-center mb-16" data-id="element-195">
          <div className="relative group max-w-md w-full" data-id="element-196">
            <div className="absolute inset-0 bg-[#1e2a4a] rounded-xl transform -rotate-3 opacity-10 transition-transform group-hover:-rotate-6" data-id="element-197"></div>
            <img src="https://cdn.magicpatterns.com/uploads/ehu4RFUCtJ7grHgEG1amUi/cover2_sales_page.png" alt="Bedtime Pass Kit Tablet View" className="relative rounded-xl shadow-lg w-full h-auto transform transition-transform group-hover:-translate-y-2" data-id="element-198" />
          </div>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="bg-[#fffdf8] p-8 md:p-12 rounded-2xl border border-[#c9a96e]/20 shadow-sm max-w-[680px] mx-auto" data-id="element-199">
          <h3 className="text-2xl md:text-3xl font-serif font-bold text-[#1e2a4a] mb-2 text-center" data-id="element-200">
            What You Get (Instant Digital Download)
          </h3>
          <p className="text-center text-[#6b7fa3] mb-8" data-id="element-201">Inside the kit:</p>

          <ul className="space-y-4 mb-10" data-id="element-202">
            {deliverables.map((item, index) => <li key={index} className="flex items-start" data-id="element-203">
                <CheckCircle className="w-6 h-6 text-[#c9a96e] mr-4 flex-shrink-0 mt-0.5" data-id="element-204" />
                <span className="text-lg text-[#1e2a4a]/90" data-id="element-205">{item}</span>
              </li>)}
          </ul>

          <div className="text-center border-t border-[#c9a96e]/20 pt-8" data-id="element-206">
            <p className="text-4xl font-serif font-bold text-[#1e2a4a] mb-6 transition-opacity duration-300" style={{
            opacity: isLoading ? 0.5 : 1
          }} data-id="element-207">
              {formattedPrice}
            </p>

            <a href="https://www.gemmamama.com/cart/45504434274443:1" target="_blank" rel="noopener noreferrer" onClick={trackAddToCart} className="group inline-flex items-center justify-center px-8 py-4 text-lg font-bold text-[#1e2a4a] transition-all duration-200 bg-[#c9a96e] rounded-full hover:bg-[#d4b67d] shadow-lg shadow-[#c9a96e]/20 w-full md:w-auto" data-id="element-208">
              Download & print tonight
              <ArrowRight className="ml-2 h-5 w-5 transition-transform group-hover:translate-x-1" data-id="element-209" />
            </a>
          </div>
        </motion.div>
      </div>
    </section>;
}